import { render, staticRenderFns } from "./dcTabPaneTem.vue?vue&type=template&id=1ee4e569"
import script from "./dcTabPaneTem.vue?vue&type=script&lang=js"
export * from "./dcTabPaneTem.vue?vue&type=script&lang=js"
import style0 from "./dcTabPaneTem.vue?vue&type=style&index=0&id=1ee4e569&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports